// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__2TwzJ","container":"Image_container__22aLw","shadow":"Image_shadow__1aWqb"};